interface KeyboardEventListener {
  (event: KeyboardEvent): void;
}

type addEventListenerOptions = boolean | AddEventListenerOptions;
type callbackType = EventListener | KeyboardEventListener;

class Events {
  private namespaces: { [key: string]: callbackType };

  private scope: EventTarget; // e.g. Window, Element, Document

  constructor(scope: EventTarget | null = null) {
    this.namespaces = {};
    this.scope = scope || window;
  }

  on(
    event: string,
    cb: callbackType,
    options: addEventListenerOptions | null = null,
  ) {
    this.namespaces[event] = cb;
    const actualOptions = options || false;
    const type = event.split('.')[0];
    this.scope.addEventListener(type, <EventListener>cb, actualOptions);
    return this;
  }

  off(event: string) {
    if (!this.namespaces[event]) return;
    const type = event.split('.')[0];
    const callback = this.namespaces[event];
    this.scope.removeEventListener(type, <EventListener>callback);
    delete this.namespaces[event];
    return this;
  }

  getActive() {
    return Object.getOwnPropertyNames(this.namespaces);
  }

  purge() {
    for (const member in this.namespaces) delete this.namespaces[member];
  }

  getScope() {
    return this.scope;
  }
}

const w = new Events(window);
const d = new Events(document);

export { Events, w, d };
